import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TransitTimeOnboardingComponent} from "./transit-time-onboarding/transit-time-onboarding.component";

@Component({
  selector: 'app-onboarding-requests',
  templateUrl: './onboarding-requests.component.html',
  styleUrls: ['./onboarding-requests.component.scss']
})
export class OnboardingRequestsComponent implements OnInit {
  @Input('pageData') pageData;
  @ViewChild(TransitTimeOnboardingComponent) private transitTimeOnboardingComponent: TransitTimeOnboardingComponent;

  selected = 1;

  desiredComponent: any = TransitTimeOnboardingComponent;

  constructor() {
  }

  ngOnInit() {
  }

  assignComponent(component) {
    if (component === 'transitTimeOnboardingComponent') {
      this.selected = 1;
      this.desiredComponent = TransitTimeOnboardingComponent;
    }
  }

}
